import React from 'react';
import { LandingPage } from './components/LandingPage';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel('937331855399019');
  return <LandingPage data-id="element-0" />;
}